import React from 'react';
import { CATEGORIAS, noIdioma, tituloCurto } from '../../config/posts';
import { Link, useIdioma } from '../../i18n';
import { useFormato } from '../../i18n/formato';
import '../../styles/Notas.css';

const DATA = { day: 'numeric', month: 'short', year: 'numeric' };

/** Um post numa lista: data e categoria à esquerda, título e resumo à direita. */
const LinhaDoPost = ({ post }) => {
  const { t, idioma } = useIdioma();
  const { data } = useFormato();

  return (
    <li>
      <Link to={`/blog/${post.slug}`} className="notas-linha">
        <span className="notas-linha-meta">
          <time dateTime={post.data}>{data(post.data, DATA)}</time>
          <span>
            {t(CATEGORIAS[post.categoria].chave)} · {t('notas.minutos', { n: post.leitura })}
          </span>
        </span>
        <span>
          <span className="notas-linha-titulo">
            {tituloCurto(post, idioma)}
            <span className="nh-seta" aria-hidden="true">→</span>
          </span>
          <span className="notas-linha-resumo">{noIdioma(post.resumo, idioma)}</span>
        </span>
      </Link>
    </li>
  );
};

export default LinhaDoPost;
